module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Recording",
      "disabled": _vm.disableRecording
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), (_vm.culturalResourceRecordingLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.culturalResourceRecordingLoading) ? _c('form', {
    staticClass: "form",
    attrs: {
      "id": "sticky"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(!_vm.isSegment) ? _c('div', {
    staticClass: "sticky"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#location"
    }
  }, [_vm._v("Location")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#nationalRegisterStatus"
    }
  }, [_vm._v("Register Status")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#investigativeHistory"
    }
  }, [_vm._v("Investigative History")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#propertyDescription"
    }
  }, [_vm._v("Property Description")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#siteSetting"
    }
  }, [_vm._v("Site Setting")])])])]) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": !_vm.isShpoCrApprovingUser && _vm.formDisabled
    }
  }, [_c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "overview"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('identificationForm', {
    ref: "identificationForm",
    style: (_vm.identificationStyle),
    attrs: {
      "culturalResourceRecording": _vm.culturalResourceRecording,
      "culturalResource": _vm.culturalResource,
      "formDisabled": _vm.formComponentDisabled.identification,
      "isShpoCr": _vm.isShpoCr,
      "otherCrrList": _vm.otherCrrList,
      "qaqcEnabled": false,
      "attachmentString": _vm.attachmentString,
      "recordingOrganization": _vm.project.fieldOrgDescription,
      "isShpoCrApprovingUser": _vm.isShpoCrApprovingUser,
      "source": "CulturalResourceRecording"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "location"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Location")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('locationForm', {
    ref: "locationForm",
    style: (_vm.locationStyle),
    attrs: {
      "formDisabled": _vm.formComponentDisabled.location,
      "qaqcEnabled": false,
      "crrId": _vm.culturalResourceRecordingId,
      "siteTrsList": _vm.siteTrsList
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    style: (_vm.nationalRegisterStatusStyle),
    attrs: {
      "id": "nationalRegisterStatus"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("National Register Status")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formComponentDisabled.nationalRegister
    }
  }, [_c('nationalRegisterStatusForm', {
    attrs: {
      "isConditionReport": _vm.isConditionReport,
      "formDisabled": _vm.formComponentDisabled.nationalRegister,
      "qaqcEnabled": false,
      "crrId": _vm.culturalResourceRecordingId
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    style: (_vm.investigativeHistoryStyle),
    attrs: {
      "name": "inventoryHistoryPanel",
      "id": "investigativeHistory"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Investigative History")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formComponentDisabled.investigativeHistory
    }
  }, [_c('investigativeHistoryForm', {
    attrs: {
      "formDisabled": _vm.formComponentDisabled.investigativeHistory,
      "qaqcEnabled": false,
      "crrId": _vm.culturalResourceRecordingId
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    style: (_vm.propertyDescriptionStyle),
    attrs: {
      "id": "propertyDescription"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Property Description")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formComponentDisabled.propertyDescription
    }
  }, [_c('propertyDescriptionForm', {
    attrs: {
      "formDisabled": _vm.formComponentDisabled.propertyDescription,
      "qaqcEnabled": false,
      "crrId": _vm.culturalResourceRecordingId
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isSegment) ? _c('div', {
    staticClass: "panel panel-offset",
    style: (_vm.siteSettingStyle),
    attrs: {
      "name": "siteSettingPanel",
      "id": "siteSetting"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Site Setting")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.formComponentDisabled.siteSetting
    }
  }, [_c('siteSettingForm', {
    attrs: {
      "formDisabled": _vm.formComponentDisabled.siteSetting,
      "qaqcEnabled": false,
      "crrId": _vm.culturalResourceRecordingId
    }
  })], 1)])]) : _vm._e()])])]) : _vm._e()], 1), _vm._v(" "), (_vm.culturalResourceRecording.siteTypeId !== _vm.propertyTypeEnum.Building) ? _c('tab', {
    attrs: {
      "header": _vm.isConditionReport ? 'Condition Narrative' : 'Site Narrative',
      "disabled": _vm.isInternalReview
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(!_vm.culturalResourceRecordingLoading) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "siteNarrative"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.isConditionReport ? 'CONDITION NARRATIVE' : 'SITE NARRATIVE'))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), (_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.culturalResourceRecording.siteNarrative)
    }
  })]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('editor', {
    attrs: {
      "id": "editorSiteNarrative",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.culturalResourceRecording.siteNarrative),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "siteNarrative", $$v)
      },
      expression: "culturalResourceRecording.siteNarrative"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveSiteNarrative
    }
  }, [_vm._v("Save")])]) : _vm._e()])])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.culturalResourceRecording.siteTypeId == _vm.propertyTypeEnum.Building) ? _c('tab', {
    attrs: {
      "header": "Property Desc./History",
      "disabled": _vm.isInternalReview
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(!_vm.culturalResourceRecordingLoading) ? _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "panel panel-offset",
    attrs: {
      "id": "siteNarrative"
    }
  }, [_c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("PROPERTY DESCRIPTION/HISTORY")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("PROPERTY DESCRIPTION")]), _vm._v(" "), (_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.culturalResourceRecording.buildingDescription)
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.culturalResourceRecording.buildingDescription),
      expression: "culturalResourceRecording.buildingDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "10"
    },
    domProps: {
      "value": (_vm.culturalResourceRecording.buildingDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.culturalResourceRecording, "buildingDescription", $event.target.value)
      }
    }
  })]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('editor', {
    attrs: {
      "id": "editorBuildingDesc",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.culturalResourceRecording.buildingDescription),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "buildingDescription", $$v)
      },
      expression: "culturalResourceRecording.buildingDescription"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("PROPERTY HISTORY")]), _vm._v(" "), (_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control",
    staticStyle: {
      "height": "auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.culturalResourceRecording.buildingHistory)
    }
  })]) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('editor', {
    attrs: {
      "id": "editorBuildingHist",
      "init": _vm.editor.options
    },
    model: {
      value: (_vm.culturalResourceRecording.buildingHistory),
      callback: function($$v) {
        _vm.$set(_vm.culturalResourceRecording, "buildingHistory", $$v)
      },
      expression: "culturalResourceRecording.buildingHistory"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    on: {
      "click": _vm.saveSiteNarrative
    }
  }, [_vm._v("Save")])]) : _vm._e()])])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.isRestrictedRole) ? _c('tab', {
    attrs: {
      "header": "Map",
      "disabled": _vm.culturalResourceRecordingLoading
    }
  }, [_c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeId,
      "parentId": _vm.culturalResourceRecordingId,
      "loadOnMount": false,
      "smithsonianNo": _vm.smithsonianNoForMap,
      "crrShowShapefile": _vm.isFirstOrFullRerecord
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Documents",
      "disabled": _vm.isInternalReview
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('siteFormDocuments', {
    ref: "siteFormDocuments",
    attrs: {
      "formDisabled": _vm.formDisabled && !_vm.qaqcEnabled,
      "loadOnMount": false
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('hr'), _vm._v(" "), _c('mediaLetter', {
    ref: "mediaLetter",
    attrs: {
      "parentId": _vm.culturalResourceRecordingId,
      "mediaTypeId": _vm.mediaTypeIdCrrLetter,
      "loadOnMount": false
    }
  })], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "disabled": _vm.isConditionReport || _vm.isSiteLead || _vm.isInternalReview,
      "header": "Attachments"
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('attachments', {
    ref: "attachments",
    attrs: {
      "formDisabled": _vm.formDisabled,
      "qaqcEnabled": false,
      "crrId": _vm.culturalResourceRecordingId,
      "loadOnMount": true,
      "projectId": _vm.project.projectId,
      "attachments": _vm.attachmentString
    },
    on: {
      "update:attachments": function($event) {
        _vm.attachmentString = $event
      }
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Eligibility/Submission"
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('siteFormEligibility', {
    ref: "eligibility",
    attrs: {
      "id": "eligibility",
      "isConditionReport": _vm.isConditionReport,
      "isInternalReview": _vm.isInternalReview,
      "culturalResourceRecording": _vm.culturalResourceRecording,
      "culturalResource": _vm.culturalResource,
      "hasAgencyAccess": _vm.hasAgencyAccess,
      "hasShpoAccess": _vm.hasShpoAccess,
      "isNormalization": _vm.isNormalization
    },
    on: {
      "workflowLoaded": _vm.setWorkflowLoaded,
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1), _vm._v(" "), (_vm.isShpo) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "projectId": _vm.project.projectId,
      "investigationId": _vm.investigation.investigationId,
      "culturalResourceRecordingId": _vm.culturalResourceRecordingId,
      "parentId": _vm.culturalResourceRecordingId,
      "mediaTypeId": _vm.mediaTypeIdCrrLetter
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.culturalResourceRecordingId) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.reportLoading,
      "name": "siteFormReport"
    },
    on: {
      "click": _vm.genSiteFormReport
    }
  }, [_vm._v("Generate Site Form Report")])]) : _vm._e()], 1), _vm._v(" "), (_vm.qaqcEnabled) ? _c('tab', {
    attrs: {
      "header": "QA/QC"
    }
  }, [_c('projectHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.project),
      expression: "project"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('investigationHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.investigation),
      expression: "investigation"
    }],
    attrs: {
      "investigation": _vm.investigation
    }
  }), _vm._v(" "), _c('siteHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResource),
      expression: "culturalResource"
    }],
    attrs: {
      "culturalResource": _vm.culturalResource,
      "siteName": _vm.culturalResourceRecording.siteName,
      "currentEval": _vm.currentEval
    }
  }), _vm._v(" "), _c('qaqcCulturalResourceRecording', {
    ref: "qaqc",
    attrs: {
      "culturalResource": _vm.culturalResource,
      "loadOnMount": false
    }
  })], 1) : _vm._e()], 1)], 1)]), _vm._v(" "), (_vm.isDebug) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ecdf94e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CulturalResourceRecording.vue
// module id = 909
// module chunks = 1